export default {
  film: [
    "2_TUT.jpg",
    "KRALICEK_1.jpg",
    "KRALICEK_2.jpg",
    "KRALICEK_3.jpg",
    "JOHN_MOGENSEN_FM_1.jpg",
    "M_A_S_FM1.jpg",
    "PS_FM1.jpg",
    "PS_FM2.jpg",
    "TANECNICE_FM1.jpg",
    "SERENA_FM_1.jpg",
    "SERENA_FM_2.jpg",
    "SERENA_FM_3.jpg",
    "AGORA_FM1.jpg",
    "BOND_FM1.jpg",
    "DOOM_FM1.jpg",
    "DOOM_FM2.jpg",
    "DOOM_FM3.jpg",
  ],
  commercials: [
    "2025MS_ETSY-2.jpg",
    "2025MS_SAMSUNG_FOLD_7.jpg",
    "2025MS_UBER_EATS_Jolly_Ranchers.jpg",
    "2025MS_UBER_EATS_Jolly_Ranchers-2.jpg",
    "2025MS_UBER_EATS_Mild_Salsa.jpg",
    "2025MS_UBER_EATS_Passion_fruit.jpg",
    "2025MS_UBER_EATS_Passion-fruit2.jpg",
    "2025MS_UBER_EATS_Pirates_Booty.jpg",
    "2025MS_UBER_EATS_Berts_bees.jpg",
    "2_WANTED.jpg",
    "CS_NERATOV_FM1.jpg",
    "CS_ZISOV-FM1.jpg",
    "2_SAMSUNGADDWASH.jpg",
    "COTE_D_OR_FM_1.jpg",
    "CRAYOLA_FM1.jpg",
    "IPHONE_FM1.jpg",
    "CUBUS_FM1.jpg",
    "2_GARNIERCN2015.jpg",
    "GARNIER_FM1.jpg",
    "CANAL_PLAY_FM1.jpg",
    "NETFLIX_FM1.jpg",
    "NETFLIX_FM2.jpg",
    "NETFLIX_FM3.jpg",
    "AXE_FM1.jpg",
    "AXE_FM2.jpg",
    "COREGA_FM1.jpg",
    "LIDL_FM1.jpg",
    "CURRYS_FM1.jpg",
    "DIET_COKE_FM1.jpg",
    "HEINEKEN_FM1.jpg",
    "HP_FM1.jpg",
    "SONY_FM1.jpg",
    "SONY_FM2.jpg",
    "SONY_FM3.jpg",
    "VIVELL_FM1.jpg",
    "VIVELL_FM2.jpg",
  ],
  series: [
    "2_FOUND3-2.jpg",
    "2_FOUND2-2.jpg",
    "2_ZERV.jpg",
    "2_DASBOOT.jpg",
    "DB_1.jpg",
    "DB_2.jpg",
    "DB_3.jpg",
    "DB_4.jpg",
    "MARS_FM1.jpg",
    "MARS_FM2.jpg",
    "MARS_FM3.jpg",
    "MARS_FM4.jpg",
    "CL_FM1.jpg",
    "CL_FM2.jpg",
    "Z_1864_FM1.jpg",
    "Z_1864_FM2.jpg",
    "Z_1864_FM3.jpg",
  ],
  about: [],
};
